<template>
  <div id="main">
    <div class="title">
      <h3>全媒体运营师职业技能等级证书查询</h3>
      <p>All media operator professional skill level certificate query</p>
    </div>
    <div class="search">
      <el-form
        :model="form"
        ref="search"
        :rules="rules"
        label-width="80px"
        :inline="true"
        size="normal"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="证书编号">
          <el-input v-model="form.certificate"></el-input>
        </el-form-item>
        <el-form-item label="身份号" prop="id_card">
          <el-input
            v-model.trim="form.id_card"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div id="search" @click="onSubmit">点击查询</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="class">
      该查询信息来自国家广播电视总局广播电视和网络视听播音主持教育培训基地
    </div>
    <div class="certificate" v-show="show" v-html="certificate"></div>
  </div>
</template>

<script>
export default {
  name: "",
  metaInfo() {
    return this.metaData;
  },
  data() {
    return {
      show: false,
      certificate: "",
      metaData: {
        title: "全媒体运营师培等级证书查询_泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content:
              "网络视听主播培训、短视频运营培训、全媒体运营师培训职业技能等级证书查询",
          },
          {
            name: "description",
            content:
              "由国家广播电视总局教育培训基地主办与颁发全媒体运营师职业技能证书信息查询官网。",
          },
        ],
      },
      rules: {
        name: { required: true, message: "请输入姓名", trigger: "blur" },
        id_card: { required: true, message: "请输入身份证号", trigger: "blur" },
      },
      form: {
        name: "",
        id_card: "",
        certificate: "",
      },
    };
  },
  mounted() {
    if (this.isMobile(navigator.userAgent)) {
      let url = window.location.origin.replace(/www/, "m");
      window.location.href = url + "/page/h5/search.html";
    }
  },
  methods: {
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/);
    },
    onSubmit() {
      let that = this;
      this.$refs.search.validate((valid) => {
        if (valid) {
          that.$axios
            .post("/search", that.form)
            .then((res) => {
              if (res.code === 0) {
                that.show = true;
                that.certificate = res.data;
              } else {
                that.$message.error("搜索失败，请检查参数后查询");
              }
            })
            .catch((error) => {
              alert(error);
              // that.$message.error(error)
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.certificate {
  .zs {
    width: 840px;
    height: auto;
    margin: 0 auto;
    border: 10px solid #f0f0f0;
    background: url(../../../assets/image/as.jpg) no-repeat center center;
    background-size: cover;
    padding: 100px 70px;
    box-sizing: border-box;
    text-align: center;
    h3 {
      font-size: 40px;
      color: #333;
      font-family: "fz";
      padding-top: 60px;
    }
    h2 {
      font-size: 65px;
      color: #333;
      font-family: "fz";
    }
    img {
      max-width: 100%;
    }
  }
}
.zs_text {
  padding-top: 100px;
  padding-bottom: 150px;
  display: flex;
  flex-wrap: wrap;
}
.zs_text p {
  width: 50%;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  line-height: 70px;
}

.zs_text p:nth-child(2n) {
  width: 50%;
}
.zs_text p i,
.zs_text p span {
  font-size: 18px;
  color: #000;
  display: inline-block;
  vertical-align: middle;
  font-style: normal;
}
.zs_btnm {
  display: flex;
}
.zs_btnm > div {
  width: 50%;
  display: inline-block;
  vertical-align: middle;
}
.zsbtm_l {
  text-align: left;
}
.zsbtm_l img {
  width: 110px;
  height: 110px;
  display: inline-block;
}
.zsbtm_r {
  text-align: right;
}

.zsbtm_r h4 {
  font-size: 18px;
  color: #000;
  vertical-align: middle;
  display: inline-block;
  padding-right: 30px;
  font-weight: 400;
}
.zsbtm_rs {
  vertical-align: middle;
  display: inline-block;
  position: relative;
}
.zsbtm_rs img {
  max-width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  -moz-transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  -o-transform: translateY(-50%) translateX(-50%);
}
.zsbtm_rs p {
  font-size: 13px;
  color: #000;
  line-height: 26px;
  text-align: center;
}
.zscx_false {
  width: 840px;
  height: auto;
  margin: 0 auto;
  border: 10px solid #f0f0f0;
  background-size: cover;
  padding: 100px 70px;
  box-sizing: border-box;
  text-align: center;
}
</style>
<style lang="scss" scoped>
#search {
  width: 141px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  background: #0c81fe;
  border-radius: 5px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
#search:hover {
  opacity: 0.8;
}
#main {
  background: #f5faff;
  box-sizing: border-box;
  padding-bottom: 50px;
  > .title {
    padding-top: 99px;
    text-align: center;
    padding-bottom: 66px;
    h3 {
      font-size: 32px;
      margin-bottom: 27px;
    }
    p {
      font-size: 14px;
      color: #7d8a9c;
    }
  }
  .class {
    font-size: 14px;
    color: #7d8a9c;
    margin: 57px auto 20px;
    text-align: center;
  }
}
</style>
